module.exports = { Stream: function () {} };
